:host {
  display: block;
}
:host ul {
  padding: 0;
  margin: 0;
}